import Breadcrumb from '../../core/components/UI/Breadcrumb'
import { useCountryContext } from '../../core/context/country/CountryProvider'
import FormEditOpportunity from '../components/opportunity-edit-page/FormEditOpportunity'
import { useOpportunityContext } from '../context/opportunity/OpportunityProvider'

export default function OpportunityEditPage() {
  const { countryState } = useCountryContext()
  const { opportunityState } = useOpportunityContext()
  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المناطق',
            isActive: false,
            to: `/countries/opportunities`,
          },
          {
            id: 2,
            label: countryState.country?.name_ar,
            isActive: false,
            to: `/countries/opportunities`,
          },
          {
            id: 3,
            label: 'الفرص الاستثمارية',
            isActive: false,
            to: '/countries/opportunities',
          },
          {
            id: 4,
            label: opportunityState.opportunity?.title_ar,
            isActive: false,
            to: '/countries/opportunities',
          },
          {
            id: 5,
            label: 'تعديل',
            isActive: true,
          },
        ]}
      />
      <div className="border-2 border-muted-500 bg-white p-2">
        {opportunityState.isLoading ? (
          <>....</>
        ) : (
          <FormEditOpportunity opportunity={opportunityState.opportunity} />
        )}
      </div>
    </>
  )
}
